import { ECS } from '../state';
import { randomInRange } from '~/helpers/MathUtils';
import { urls } from '@/config/assets';
import { beerConfig } from '@/config/games/beer';
import sample from 'lodash/sample';
import { getUrlBoolean } from '~/helpers/UrlParam';
import AssetService from '@/services/AssetService';
import { useState, useRef, useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import { useAsset } from '@/hooks/useAsset';

const debug = getUrlBoolean('debug');

export const Obstacles = () => {
  // DEBUG
  // useEffect(() => {
  //   let type = 'haybale';
  //   let width = itemSizes[type][0];
  //   let height = itemSizes[type][1];
  //   addObstacle(2, 0, width, height, type);
  // }, []);

  return (
    <>
      <ECS.Entities
        in={obstacles}
        children={Obstacle}
      />
    </>
  );
};

export const Obstacle = (entity) => {
  if (entity.type == 'truck') return;

  const refSprite = useRef();

  const [
    //
    t_haybale,
    t_cow,
    t_scarecrow,
    t_cloud,
    t_truck,
    t_wasps,
  ] = useAsset([
    //
    urls.t_haybale,
    urls.t_cow,
    urls.t_scarecrow,
    urls.t_cloud,
    urls.t_truck,
    urls.t_wasps,
  ]);

  const textures = {
    haybale: t_haybale,
    cow: t_cow,
    scarecrow: t_scarecrow,
    cloud: t_cloud,
    wasps: t_wasps,
  };

  const texture = textures[entity.type];

  const offsets = {
    haybale: [0, 0, -0.005],
    cow: [-0.1, 0.1, 0],
    scarecrow: [0, 0.05, 0],
    cloud: [0, 0, 0],
    wasps: [0, 0, 0],
  };

  const spritePosition = [
    offsets[entity.type][0],
    offsets[entity.type][1] + entity.size[1] * 0.5,
    offsets[entity.type][2] + 0.01,
  ];

  const scales = {
    haybale: 1.15,
    cow: [1.4, 1.75, 1],
    scarecrow: [1 / (itemSizes.scarecrow[0] / itemSizes.scarecrow[1]), 1, 1],
    cloud: 1,
    wasps: [1.5 / (itemSizes.wasps[0] / itemSizes.wasps[1]), 1.5, 1.5],
  };

  // **********************************************************************
  // HIT SFX
  // **********************************************************************
  const [isHit, setIsHit] = useState(false);

  useFrame(() => {
    if (entity.isHit && !isHit) {
      setIsHit(true);
    }
  });

  useEffect(() => {
    if (!isHit) return;

    // console.log('obstacle collided play sfx', `s_collision_${entity.type}`);
    let sfx = AssetService.getAsset(`s_collision_${entity.type}`);
    if (sfx) {
      sfx.play();
    }
  }, [isHit]);

  // **********************************************************************
  // ON SCREEN SFX
  // **********************************************************************
  // const [isOnScreen, setIsOnScreen] = useState(false);
  // useFrame(() => {
  //   if (entity.onScreen && !isOnScreen) {
  //     setIsOnScreen(true);
  //   } else if (isOnScreen && !entity.onScreen) {
  //     setIsOnScreen(false);
  //   }
  // });

  return (
    <ECS.Entity entity={entity}>
      <ECS.Component name="three">
        <group>
          <group position={[0, 0, 0]}>
            {debug && (
              <group>
                <mesh position={[0, entity.size[1] * 0.5, 0.01]}>
                  <planeGeometry args={[entity.size[0], entity.size[1]]} />
                  <meshBasicMaterial
                    // color={isOnScreen ? 'green' : 'red'}
                    color="red"
                    transparent
                    opacity={0.5}
                  />
                </mesh>
                <mesh position={[0, 0, 0.01]}>
                  <sphereGeometry args={[0.05]} />
                  <meshBasicMaterial
                    // color={isOnScreen ? 'green' : 'red'}
                    color="red"
                    transparent
                    opacity={0.5}
                  />
                </mesh>
              </group>
            )}
            <mesh
              scale={scales[entity.type]}
              position={spritePosition}
            >
              <planeGeometry args={[entity.size[0], entity.size[1]]} />
              <GBufferMaterial
                transparent
                // depthTest={false}
              >
                {/* <MaterialModuleColor color="red" /> */}
                <MaterialModuleMap map={texture} />

                {entity.sprite && (
                  <MaterialModuleSpriteAnimated
                    ref={refSprite}
                    map={texture}
                    rows={entity.sprite.rows}
                    cols={entity.sprite.cols}
                    frames={entity.sprite.frames}
                    auto={true}
                    fps={entity.sprite.fps}
                  />
                )}

                <MaterialModuleAlphaTest />
              </GBufferMaterial>
            </mesh>
          </group>
        </group>
      </ECS.Component>
    </ECS.Entity>
  );
};

export const clearObstacles = () => {
  ECS.world.remove(obstacles);
};

// export const addObstacles = (areaIdx) => {
//   const area = beerConfig.areas[areaIdx];

//   let lastX = 0;

//   for (let i = 0; i < area.numObstacles; i++) {
//     const type = sample(area.obstacles);
//     const size = itemSizes[type];
//     const width = size[0];
//     const height = size[1];

//     lastX += width;

//     lastX += randomInRange(OBSTACLE_GAP_MIN, OBSTACLE_GAP_MAX);

//     addObstacle(lastX, 0, width, height, type);
//   }
// };

export const addObstacle = (
  x = 0,
  y = 0,
  width = 1,
  height = 1,
  type = 'haybale',
  opts = {}
) => {
  ECS.world.add({
    isCollidable: true,
    isStandable: true,
    isObstacle: true,
    isBlocking: true,
    position: { x, y },
    size: [width, height, 0.01],
    type,
    ...opts,
  });
};
